import { render, staticRenderFns } from "./DataEntryItem.vue?vue&type=template&id=561338d5&scoped=true&"
import script from "./DataEntryItem.vue?vue&type=script&lang=js&"
export * from "./DataEntryItem.vue?vue&type=script&lang=js&"
import style0 from "./DataEntryItem.vue?vue&type=style&index=0&id=561338d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561338d5",
  null
  
)

export default component.exports